export const WSB_MERCHANT_SOURCE = 'onecom_wsb';

export const GRAVITY_ACTIVATION_CLASS = 'gv-activated gv-h-full';

export const GRAVITY_DESIGN_APPS = [
  'ai-receptionist',
  'calendar-v2-gsd',
  'services-v2',
  'settings-v2',
  'appointment-v3',
  'reminders-v2',
];

// to update GRAVITY_DESIGN_VERSION, check "index.html.ejs" page, search for "gravity.group-cdn.one" links
